export default {
    set (key, value) {
        window.localStorage[key] = value
        return this
    },
    get (key, defaultValue) {
        return window.localStorage[key] || defaultValue
    },
    setObject (key, value) {
        window.localStorage[key] = JSON.stringify(value)
        return this.getObject(key)
    },
    getObject (key) {
        return JSON.parse(window.localStorage[key] || null)
    },
    remove (key) {
        window.localStorage.removeItem(key)
    },
    clear () {
        localStorage.clear()
    }
}



// WEBPACK FOOTER //
// ./src/services/session-storage.js